import React, {useState} from 'react'

type ExpandControlVariant = 'none' | 'checkbox' | 'collapse'

interface WizardSectionCardProps {
  title: string
  subTitle?: string
  isRequired?: boolean
  isValid?: boolean
  children: React.ReactNode
  className?: string
  iconClassName?: string
  variant?: ExpandControlVariant
  defaultExpanded?: boolean
  onExpandedChange?: (expanded: boolean) => void
  collapsedTitleAccessory?: React.ReactNode
  collapsedMessage?: React.ReactNode
}

const WizardSectionCard: React.FC<WizardSectionCardProps> = ({
  title,
  subTitle = '',
  isRequired = false,
  isValid = false,
  children,
  className = '',
  iconClassName = '',
  variant = 'none',
  defaultExpanded = false,
  onExpandedChange,
  collapsedTitleAccessory,
  collapsedMessage,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  const showContent = variant === 'none' ? true : isExpanded
  const showCollapsedDetails = variant !== 'none' && !isExpanded

  const handleExpandedChange = (expanded: boolean) => {
    setIsExpanded(expanded)
    onExpandedChange?.(expanded)
  }

  return (
    <section className={`wizard-section-card ${className}`}>
      <div className='d-flex justify-content-between align-items-start'>
        {/* Left Side */}
        <div className='d-flex gap-4 flex-grow-1'>
          {variant === 'checkbox' && (
            <input
              type='checkbox'
              className='form-check-input mt-1'
              checked={isExpanded}
              onChange={(e) => handleExpandedChange(e.target.checked)}
            />
          )}

          {iconClassName && <i className={`${iconClassName} mt-1`} />}

          <div>
            <div className='d-flex align-items-center gap-2 flex-wrap'>
              <h4 className='mb-0'>{title}</h4>

              {showCollapsedDetails && collapsedTitleAccessory}

              {isRequired && <span className='pill pill-req'>Required</span>}
            </div>

            {subTitle && <div className='text-muted fs-6 mt-1'>{subTitle}</div>}
            {showCollapsedDetails && collapsedMessage}
          </div>
        </div>

        {variant === 'collapse' && (
          <button
            type='button'
            className='btn btn-sm btn-link text-decoration-none d-flex align-items-center gap-1'
            onClick={() => handleExpandedChange(!isExpanded)}
          >
            <i className={`fas ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
          </button>
        )}
      </div>

      {/* Content */}
      {showContent && <div className='mt-4'>{children}</div>}
    </section>
  )
}

export default WizardSectionCard
